import { useNavigate } from 'react-router-dom';
import { Check, Lock } from 'lucide-react';
import type { FC } from 'react';
import { useAppStore } from '../store/useAppStore';
import type { CourseProgress, Lesson } from '../api/client';
import { t } from '../i18n';

/**
 * Kursdagi darslar — dars ekranining CHAP USTUNI.
 *
 * NEGA BU ALOHIDA QOBIQ: Mini App'da dars ekrani butun sahifani
 * egallaydi va oʻquvchi roʻyxatga QAYTIB borib keyingisini tanlaydi —
 * telefonda toʻgʻri naqsh. Kompyuterda esa ekran keng va bu ortiqcha
 * ikki qadam: roʻyxat yonda turgani maʼqul.
 *
 * Bu CSS bilan hal boʻlmaydi — media soʻrovi elementni yashira oladi,
 * lekin BOSHQA TUZILMA chiza olmaydi. Shuning uchun qobiq darajasida
 * ajratildi (`useWideScreen`), mantiq esa umumiy qoldi.
 */
export const LessonSidebar: FC<{
  course: CourseProgress;
  currentId?: string;
}> = ({ course, currentId }) => {
  const navigate = useNavigate();
  const setSelectedLesson = useAppStore((s) => s.setSelectedLesson);

  /*
   * Ochilish qoidasi `CourseListPage` dagi bilan bir xil: birinchi
   * tugallanmagan darsgacha hammasi ochiq. Bu yerda uni QAYTA
   * hisoblamaymiz — server allaqachon `isUnlocked` beradi.
   */
  const open = (l: Lesson, moduleName: string) => {
    if (!l.isUnlocked) return;
    setSelectedLesson({ ...l, moduleTitle: moduleName } as any);
    navigate(`/lesson/${l.id}`);
  };

  return (
    <aside className="lesson-sidebar" aria-label={t('Darslar')}>
      {course.modules.map((mod, mIdx) => (
        <section key={mod.id} style={{ marginBottom: 'var(--space-4)' }}>
          <div
            className="stat-label"
            style={{ marginBottom: 'var(--space-2)' }}
          >
            {mod.title}
          </div>

          <div className="stack" style={{ gap: 2 }}>
            {mod.lessons.map((l, lIdx) => {
              const current = l.id === currentId;
              return (
                <button
                  key={l.id}
                  type="button"
                  className={`sidebar-row${current ? ' is-active' : ''}`}
                  onClick={() => open(l, mod.title)}
                  disabled={!l.isUnlocked}
                  aria-current={current ? 'page' : undefined}
                >
                  <span className="sidebar-row-num">
                    {mIdx + 1}.{lIdx + 1}
                  </span>
                  <span className="sidebar-row-title">{l.title}</span>
                  {l.isCompleted ? (
                    <Check
                      size={13}
                      aria-hidden="true"
                      style={{ color: 'var(--success)', flex: 'none' }}
                    />
                  ) : !l.isUnlocked ? (
                    <Lock
                      size={12}
                      aria-hidden="true"
                      style={{ color: 'var(--ink-muted)', flex: 'none' }}
                    />
                  ) : null}
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </aside>
  );
};
